/*
 * Resource cards — changelog / blog / Danish Foundation Models.
 */

import { icon, type IconName } from "./icons";
import type { ResourcesContent } from "../i18n/types";

/** Resource card accents, icons and hrefs — structural, zipped with the
 * card content in the dictionary. A null href renders a plain card
 * (no link) for self-contained content like the director's note. */
const RESOURCE_META = [
  { variant: "green", iconName: "history" as IconName, href: null },
  { variant: "blue", iconName: "bolt" as IconName, href: "https://docs.cloud.sdu.dk/" },
  { variant: "purple", iconName: "sparkle" as IconName, href: "https://www.foundationmodels.dk/" },
] as const;

export function renderResources(t: ResourcesContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section resources";
  root.id = "resources";
  root.innerHTML = `
    <div class="page">
      <div class="section-head section-head--center" data-reveal>
        <h2 class="section__title">${t.title}</h2>
        <p class="section__lead">${t.lead}</p>
      </div>
      <div class="resources__grid">
        ${t.cards.map((r, i) => {
          const meta = RESOURCE_META[i];
          const href = meta.href;
          const linkAttrs = href
            ? ` href="${href}"${href.startsWith("http") ? ' target="_blank" rel="noreferrer"' : ""}`
            : "";
          return `
          <${href ? "a" : "div"} class="resource resource--${meta.variant}" data-reveal style="--reveal-delay:${i * 80}ms"${linkAttrs}>
            <div style="display:flex;align-items:center;gap:12px">
              <span style="color:var(--resourceAccent, var(--accent))">${icon[meta.iconName]({ size: 22 })}</span>
              <span class="resource__tag">${r.tag}</span>
            </div>
            <h3 class="resource__title">${r.title}</h3>
            <p class="resource__excerpt">${r.excerpt}</p>
            <div class="resource__meta">
              <span>${r.meta}</span>
              ${href ? `<span>${icon.arrow({ size: 14 })}</span>` : ""}
            </div>
          </${href ? "a" : "div"}>
          `;
        }).join("")}
      </div>
    </div>
  `;
  return root;
}
